export default __webpack_public_path__ + "static/media/391.98919f76.png";